<template>
  <div class="relative inline-block" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <div class="flex flex-nowrap justify-center items-center gap-[8px]">
      <div class="flex justify-center items-center w-[20px] h-[20px] rounded-full bg-university-primary text-white">
        <span>{{ label }}</span>
      </div>
    </div>
    <div
      v-if="isVisible"
      class="absolute flex flex-nowrap justify-start items-center bg-white p-[16px] min-w-[28rem] max-w-[36rem] rounded-[8px] text-university-primary gap-x-[8px] font-montserrat font-medium text-sm z-100"
      :class="getOffset"
      style="box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);"
    >
      <slot name="tooltip"></slot>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  isAbove: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: "",
  },
});

const isVisible = ref(false);

const getOffset = computed(() => {
  return props.isAbove
    ? "bottom-[130%] left-1/2 transform -translate-x-1/2"
    : "-bottom-[130%] left-1/2 transform -translate-x-1/2";
});

const showTooltip = () => (isVisible.value = true);
const hideTooltip = () => (isVisible.value = false);
</script>
